import { Label as FlowbiteLabel } from "flowbite-react";

export default function Label({ children }: { children: React.ReactNode }) {
  return <FlowbiteLabel className="font-bold">{children}</FlowbiteLabel>;
}
